// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contract a[data-v-c8384160]{border-bottom:1px dotted #000}.contract h6[data-v-c8384160]{font-weight:700}.contract li[data-v-c8384160]{line-height:1.8em}.contract .paragraph[data-v-c8384160]{margin:20px 0 0 0;list-style-type:circle!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
